export const common = {
    requestQuoteId: {
        type: 'number',
        presence: { allowEmpty: false },
    },
    name: {
        type: 'string',
        length: { minimum: 2, maximum: 255 },
        presence: { allowEmpty: false },
    },
    show_components_amount_on_pdf: {
        type: 'number',
        presence: { allowEmpty: false },
    },
};
